var _defs, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValue3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.4 147.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 73.71,
    cy: 73.62,
    r: 34.99
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 132.56,
    y1: 73.64,
    x2: 144.54,
    y2: 73.64
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.56,
    y1: 73.64,
    x2: 14.54,
    y2: 73.64
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.63,
    y1: 14.82,
    x2: 73.63,
    y2: 2.83
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.07,
    y1: 32.22,
    x2: 23.59,
    y2: 23.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 115.47,
    y1: 32.1,
    x2: 123.94,
    y2: 23.62
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.26,
    y1: 121.07,
    x2: 91.68,
    y2: 121.07
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.26,
    y1: 128.74,
    x2: 91.68,
    y2: 128.74
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.26,
    y1: 144.07,
    x2: 91.68,
    y2: 144.07
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.26,
    y1: 136.41,
    x2: 91.68,
    y2: 136.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue3);
export default __webpack_public_path__ + "static/media/value_3.264805dc23126e5821de676e653439ca.svg";
export { ForwardRef as ReactComponent };